import type { FC, ReactElement } from "react"

import { getTransitionTwClasses } from "@/3514/utils"

type _TProps = { fillColor: string }

const Icon: FC<_TProps> = ({ fillColor }: _TProps): ReactElement => (
    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            className={getTransitionTwClasses("all", 200)}
            d="M12.7124 8.10419L10.8033 8.08293H10.7995C10.6836 8.08293 10.5772 8.1525 10.5328 8.26069C9.84105 9.90702 8.17927 10.9505 6.39768 10.8558C4.26826 10.7437 2.5485 9.0568 2.39971 6.93125C2.31662 5.74286 2.71661 4.61054 3.52627 3.741C4.32625 2.88303 5.45472 2.39221 6.62378 2.39221C7.44118 2.39221 8.22372 2.62217 8.90584 3.06274L8.09619 3.87239C7.90679 4.06179 7.85081 4.34578 7.95321 4.59318C8.05562 4.8405 8.2952 5.0009 8.56386 5.0009H12.0845C12.4497 5.0009 12.7454 4.70332 12.7454 4.34006L12.7453 0.817449C12.7453 0.548856 12.5849 0.309265 12.3376 0.206804C12.0903 0.104401 11.8062 0.160446 11.6168 0.349778L10.6197 1.34689C9.29028 0.336252 7.65359 -0.129405 5.97827 0.0309938C2.72618 0.342097 0.158131 3.04348 0.00741005 6.31489C-0.0776313 8.14286 0.571631 9.87615 1.83538 11.1998C3.09912 12.5234 4.80149 13.2519 6.6256 13.2519C9.55306 13.2519 12.1694 11.2887 12.9887 8.47522C13.0138 8.38829 12.9965 8.29357 12.9424 8.22211C12.8882 8.15059 12.8032 8.10618 12.7124 8.10423L12.7124 8.10419Z"
            fill={fillColor}
        />
    </svg>
)

Icon.displayName = "CoachingChatRetryIcon"

export { Icon as CoachingChatRetryIcon }
